import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function HomePage({ setActivePage }) {
  const { users, currentUser, resetDemoData } = useAuth();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-10">
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-gradient-to-r from-blue-900 via-indigo-900 to-slate-900 rounded-3xl p-8 sm:p-12 text-white shadow-xl">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(59,130,246,0.3),transparent_50%)]"></div>
        <div className="relative z-10 max-w-3xl space-y-6">
          <div className="inline-flex items-center space-x-2 bg-blue-500/20 border border-blue-400/30 px-3 py-1 rounded-full text-xs font-semibold tracking-wide text-blue-200">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            <span>Prototype Version 1.0.0 • Active Session</span>
          </div>
          <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight leading-tight">
            User Authentication & <span className="text-blue-400">Registration Management</span>
          </h1>
          <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
            prince
          </p>
          <div className="flex flex-wrap gap-4 pt-2">
            <button
              onClick={() => setActivePage('register')}
              className="bg-blue-600 hover:bg-blue-500 text-white font-semibold px-6 py-3 rounded-xl shadow-lg transition-all transform hover:-translate-y-0.5 flex items-center space-x-2"
            >
              <span>Go to Registration Page</span>
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
            <button
              onClick={() => setActivePage('management')}
              className="bg-slate-800/80 hover:bg-slate-700 border border-slate-600 text-slate-200 font-semibold px-6 py-3 rounded-xl transition-all"
            >
              View Registration Management
            </button>
          </div>
        </div>
      </div>

      {/* Quick Summary Grid */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 space-y-2">
          <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Total Registered Users</div>
          <div className="text-3xl font-bold text-slate-900">{users.length}</div>
          <p className="text-xs text-slate-600">Stored locally with full persistence</p>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 space-y-2">
          <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Current User Status</div>
          <div className="text-xl font-bold text-blue-600 truncate">
            {currentUser ? currentUser.name : 'Guest User'}
          </div>
          <p className="text-xs text-slate-600">
            {currentUser ? `Role: ${currentUser.role}` : 'Browse as guest or register account'}
          </p>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 space-y-2">
          <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Authentication Module</div>
          <div className="text-lg font-bold text-emerald-600 flex items-center space-x-1.5">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <span>Fully Operational</span>
          </div>
          <p className="text-xs text-slate-600">Login, logout & secure session</p>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 space-y-2">
          <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Registration Management</div>
          <div className="text-lg font-bold text-indigo-600 flex items-center space-x-1.5">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            <span>Admin Tools</span>
          </div>
          <p className="text-xs text-slate-600">View, search, edit & delete records</p>
        </div>
      </div>

      {/* Modules & Functionality Cards */}
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-slate-900 tracking-tight">Prototype Modules & Requirements</h2>
            <p className="text-slate-600 text-sm">Implemented according to business specifications</p>
          </div>
          <button
            onClick={() => {
              if (window.confirm('Reset all prototype registrations and data to defaults?')) {
                resetDemoData();
              }
            }}
            className="text-xs text-slate-500 hover:text-rose-600 underline"
          >
            Reset Prototype Data
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Card 1: Registration Page */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 flex flex-col justify-between space-y-4 hover:border-blue-400 transition-colors">
            <div className="space-y-3">
              <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center font-bold text-xl">
                📝
              </div>
              <h3 className="text-lg font-bold text-slate-900">Change jhkljklj
  gioi   @ name and all</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                nhjjkln fahd f
              </p>
              <div className="bg-slate-50 p-3 rounded-lg border border-slate-100 text-xs text-slate-600 space-y-1">
                <div className="font-semibold text-slate-700">Required Input Fields:</div>
                <div className="grid grid-cols-2 gap-1 text-slate-600">
                  <div>• Full Name</div>
                  <div>• Email Address</div>
                  <div>• Phone Number</div>
                  <div>• Secure Password</div>
                </div>
              </div>
            </div>
            <button
              onClick={() => setActivePage('register')}
              className="w-full bg-blue-50 hover:bg-blue-100 text-blue-700 font-semibold py-2.5 rounded-xl text-sm transition-colors flex items-center justify-center space-x-2"
            >
              <span>Open Registration Page</span>
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* Card 2: Registration Management */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 flex flex-col justify-between space-y-4 hover:border-indigo-400 transition-colors">
            <div className="space-y-3">
              <div className="w-12 h-12 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center font-bold text-xl">
                ⚙️
              </div>
              <h3 className="text-lg font-bold text-slate-900">Registration Management Module</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Enables administrators and team members to oversee all registered user profiles, search records, update status, and manage user accounts securely.
              </p>
              <div className="bg-slate-50 p-3 rounded-lg border border-slate-100 text-xs text-slate-600 space-y-1">
                <div className="font-semibold text-slate-700">Management Capabilities:</div>
                <div className="grid grid-cols-2 gap-1 text-slate-600">
                  <div>• View All Registrations</div>
                  <div>• Search & Filter</div>
                  <div>• Edit User Information</div>
                  <div>• Delete / Revoke Account</div>
                </div>
              </div>
            </div>
            <button
              onClick={() => setActivePage('management')}
              className="w-full bg-indigo-50 hover:bg-indigo-100 text-indigo-700 font-semibold py-2.5 rounded-xl text-sm transition-colors flex items-center justify-center space-x-2"
            >
              <span>Open Registration Management</span>
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
